import React, { Component } from 'react';
import Grid from '../../Utils/GridProduccionA';
import { standardActions } from '../../Utils/GridProduccionA/StandardActions';

class DetalleProductoList extends Component{
    
    render(){
        const { loader, detalle } = this.props;
        return(
            <React.Fragment>
                {detalle &&
                <Grid 
                    hover 
                    striped 
                    data={detalle} 
                    loading={loader}
                    headerStyle={ { background: 'black' } } 
                >
                    <TableHeaderColumn
                        isKey
                        dataField="producto"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Producto
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="registro"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                        >
                        Registro sanitario
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fabricante"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                        >
                        Fabricante
                    </TableHeaderColumn>
                </Grid>
                }
            </React.Fragment>
        );
    }
}

export default DetalleProductoList;
